module.exports = __webpack_public_path__ + "img/aircraft.ae51c8ec.png";